{
 "code": "SA457",
 "edition": "SA457.2604",
 "pageSize": [
  595.28,
  841.89
 ],
 "source": "https://www.servicesaustralia.gov.au/sa457",
 "fields": {
  "q1_residential": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     110.7,
     442.3,
     121.8,
     453.4
    ]
   ]
  },
  "q2_no": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     65.3,
     623.7,
     76.4,
     634.8
    ]
   ]
  },
  "q3_no": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     156.0,
     359.9,
     167.1
    ]
   ]
  },
  "q3_yes": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     174.5,
     359.9,
     185.5
    ]
   ]
  },
  "q3_name": {
   "kind": "text",
   "page": 6,
   "boxes": [
    [
     331.8,
     205.6,
     566.8,
     245.1
    ]
   ]
  },
  "q3_relationship": {
   "kind": "text",
   "page": 6,
   "boxes": [
    [
     331.8,
     263.7,
     566.8,
     283.3
    ]
   ]
  },
  "q4_no": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     598.2,
     359.9,
     609.3
    ]
   ]
  },
  "q4_yes": {
   "kind": "tick",
   "page": 6,
   "boxes": [
    [
     348.8,
     616.7,
     359.9,
     627.7
    ]
   ]
  },
  "q5_na": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     110.7,
     139.0,
     121.8,
     150.1
    ]
   ]
  },
  "q7_you_family": {
   "kind": "text",
   "page": 7,
   "boxes": [
    [
     48.3,
     483.4,
     283.3,
     503.0
    ]
   ]
  },
  "q7_you_first": {
   "kind": "text",
   "page": 7,
   "boxes": [
    [
     48.3,
     518.9,
     283.3,
     538.5
    ]
   ]
  },
  "q8_you_dob": {
   "kind": "date",
   "page": 7,
   "boxes": [
    [
     48.3,
     606.7,
     76.7,
     626.6
    ],
    [
     82.3,
     606.7,
     110.7,
     626.6
    ],
    [
     116.3,
     606.7,
     173.0,
     626.6
    ]
   ]
  },
  "q9_you_male": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     96.5,
     662.0,
     107.6,
     673.1
    ]
   ]
  },
  "q9_you_female": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     96.5,
     679.0,
     107.6,
     690.1
    ]
   ]
  },
  "q11_you_phone": {
   "kind": "comb",
   "page": 8,
   "boxes": [
    [
     48.3,
     540.1,
     190.0,
     560.0
    ]
   ],
   "cells": 10
  },
  "q11_you_email": {
   "kind": "text",
   "page": 8,
   "boxes": [
    [
     48.3,
     575.6,
     283.3,
     595.2
    ]
   ]
  },
  "q7_partner_family": {
   "kind": "text",
   "page": 7,
   "boxes": [
    [
     331.8,
     483.4,
     566.8,
     503.0
    ]
   ]
  },
  "q7_partner_first": {
   "kind": "text",
   "page": 7,
   "boxes": [
    [
     331.8,
     518.9,
     566.8,
     538.5
    ]
   ]
  },
  "q8_partner_dob": {
   "kind": "date",
   "page": 7,
   "boxes": [
    [
     331.8,
     606.7,
     360.1,
     626.6
    ],
    [
     365.8,
     606.7,
     394.1,
     626.6
    ],
    [
     399.8,
     606.7,
     456.5,
     626.6
    ]
   ]
  },
  "q9_partner_male": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     380.0,
     662.0,
     391.1,
     673.1
    ]
   ]
  },
  "q9_partner_female": {
   "kind": "tick",
   "page": 7,
   "boxes": [
    [
     380.0,
     679.0,
     391.1,
     690.1
    ]
   ]
  },
  "q11_partner_phone": {
   "kind": "comb",
   "page": 8,
   "boxes": [
    [
     331.8,
     540.1,
     473.5,
     560.0
    ]
   ],
   "cells": 10
  },
  "q11_partner_email": {
   "kind": "text",
   "page": 8,
   "boxes": [
    [
     331.8,
     575.6,
     566.8,
     595.2
    ]
   ]
  },
  "q14_yes": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     65.3,
     192.9,
     76.4,
     204.0
    ]
   ]
  },
  "q15_option1": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     504.7,
     182.6,
     515.8,
     193.6
    ]
   ]
  },
  "q16_no": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     348.8,
     633.7,
     359.9,
     644.8
    ]
   ]
  },
  "q16_yes": {
   "kind": "tick",
   "page": 9,
   "boxes": [
    [
     348.8,
     652.1,
     359.9,
     663.2
    ]
   ]
  },
  "q19_no": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     612.4,
     76.4,
     623.5
    ]
   ]
  },
  "q19_yes": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     630.8,
     76.4,
     641.9
    ]
   ]
  },
  "q20_yes": {
   "kind": "tick",
   "page": 10,
   "boxes": [
    [
     65.3,
     783.9,
     76.4,
     795.0
    ]
   ]
  },
  "q22_no": {
   "kind": "tick",
   "page": 11,
   "boxes": [
    [
     65.5,
     69.6,
     76.6,
     80.7
    ]
   ]
  },
  "q23_no": {
   "kind": "tick",
   "page": 11,
   "boxes": [
    [
     348.8,
     106.4,
     359.9,
     117.5
    ]
   ]
  },
  "q23_yes": {
   "kind": "tick",
   "page": 11,
   "boxes": [
    [
     348.8,
     126.3,
     359.9,
     137.4
    ]
   ]
  },
  "q23_type": {
   "kind": "text",
   "page": 11,
   "boxes": [
    [
     336.0,
     160.3,
     562.6,
     179.9
    ]
   ]
  },
  "q23_value": {
   "kind": "text",
   "page": 11,
   "boxes": [
    [
     336.0,
     197.1,
     446.3,
     216.7
    ]
   ],
   "padLeft": 12.2
  },
  "q23_share_you": {
   "kind": "text",
   "page": 11,
   "boxes": [
    [
     395.6,
     238.2,
     446.3,
     257.8
    ]
   ]
  },
  "q23_share_partner": {
   "kind": "text",
   "page": 11,
   "boxes": [
    [
     511.8,
     238.2,
     562.6,
     257.8
    ]
   ]
  },
  "q23_partner_no": {
   "kind": "tick",
   "page": 11,
   "boxes": [
    [
     353.0,
     319.0,
     364.1,
     330.1
    ]
   ]
  },
  "q23_partner_yes": {
   "kind": "tick",
   "page": 11,
   "boxes": [
    [
     353.0,
     337.4,
     364.1,
     348.5
    ]
   ]
  },
  "q25_o1_select": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     181.5,
     95.1,
     192.6,
     106.2
    ]
   ]
  },
  "q25_o2_select": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     181.5,
     399.8,
     192.6,
     410.9
    ]
   ]
  },
  "q25_o1_value": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     52.6,
     153.2,
     162.9,
     172.8
    ]
   ],
   "padLeft": 12.2
  },
  "q25_o1_loan": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     168.8,
     153.2,
     279.1,
     172.8
    ]
   ],
   "padLeft": 12.2
  },
  "q25_o1_share_you": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     112.1,
     192.9,
     162.9,
     212.5
    ]
   ]
  },
  "q25_o1_share_partner": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     228.3,
     192.9,
     279.1,
     212.5
    ]
   ]
  },
  "q25_o1_share_other": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     112.1,
     218.4,
     162.9,
     238.0
    ]
   ]
  },
  "q25_o1_partner_no": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     69.6,
     272.3,
     80.7,
     283.3
    ]
   ]
  },
  "q25_o1_partner_yes": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     69.6,
     290.7,
     80.7,
     301.8
    ]
   ]
  },
  "q25_o2_value": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     52.6,
     533.0,
     162.9,
     552.6
    ]
   ],
   "padLeft": 12.2
  },
  "q25_o2_remaining": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     168.8,
     533.0,
     279.1,
     552.6
    ]
   ],
   "padLeft": 12.2
  },
  "q25_o2_loan": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     52.6,
     582.6,
     162.9,
     602.2
    ]
   ],
   "padLeft": 12.2
  },
  "q25_o2_share_you": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     112.1,
     622.3,
     162.9,
     641.9
    ]
   ]
  },
  "q25_o2_share_partner": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     228.3,
     622.3,
     279.1,
     641.9
    ]
   ]
  },
  "q25_o2_share_other": {
   "kind": "text",
   "page": 12,
   "boxes": [
    [
     112.1,
     647.8,
     162.9,
     667.4
    ]
   ]
  },
  "q25_o2_partner_no": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     69.6,
     704.5,
     80.7,
     715.6
    ]
   ]
  },
  "q25_o2_partner_yes": {
   "kind": "tick",
   "page": 12,
   "boxes": [
    [
     69.6,
     723.0,
     80.7,
     734.0
    ]
   ]
  },
  "q29_no": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     65.3,
     93.7,
     76.4,
     104.8
    ]
   ]
  },
  "q29_yes": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     65.3,
     112.1,
     76.4,
     123.2
    ]
   ]
  },
  "q29_value": {
   "kind": "text",
   "page": 13,
   "boxes": [
    [
     85.2,
     139.0,
     195.5,
     158.6
    ]
   ],
   "padLeft": 12.2
  },
  "q30_no": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     65.3,
     256.7,
     76.4,
     267.7
    ]
   ]
  },
  "q31_no": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     65.5,
     381.4,
     76.6,
     392.5
    ]
   ]
  },
  "q31_yes": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     65.5,
     399.8,
     76.6,
     410.9
    ]
   ]
  },
  "q33_no": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     348.8,
     58.2,
     359.9,
     69.3
    ]
   ]
  },
  "q33_yes": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     348.8,
     76.7,
     359.9,
     87.7
    ]
   ]
  },
  "q34_carer": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     501.9,
     247.5,
     512.9,
     258.6
    ]
   ]
  },
  "q34_relative": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     501.9,
     290.7,
     512.9,
     301.8
    ]
   ]
  },
  "q34_none": {
   "kind": "tick",
   "page": 13,
   "boxes": [
    [
     501.9,
     313.4,
     512.9,
     324.5
    ]
   ]
  },
  "q38_no": {
   "kind": "tick",
   "page": 15,
   "boxes": [
    [
     65.3,
     97.9,
     76.4,
     109.0
    ]
   ]
  },
  "q38_yes": {
   "kind": "tick",
   "page": 15,
   "boxes": [
    [
     65.3,
     116.3,
     76.4,
     127.4
    ]
   ]
  },
  "q40_you": {
   "kind": "tick",
   "page": 15,
   "boxes": [
    [
     102.2,
     567.1,
     113.3,
     578.1
    ]
   ]
  },
  "q40_partner": {
   "kind": "tick",
   "page": 15,
   "boxes": [
    [
     102.2,
     591.1,
     113.3,
     602.2
    ]
   ]
  },
  "q40_share_you": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     204.2,
     562.8,
     283.3,
     582.4
    ]
   ]
  },
  "q40_share_partner": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     204.2,
     586.9,
     283.3,
     606.5
    ]
   ]
  },
  "q42_value": {
   "kind": "text",
   "page": 15,
   "boxes": [
    [
     336.0,
     462.2,
     449.2,
     481.8
    ]
   ],
   "padLeft": 12.2
  },
  "q45_no": {
   "kind": "tick",
   "page": 16,
   "boxes": [
    [
     65.5,
     646.4,
     76.6,
     657.5
    ]
   ]
  },
  "q45_yes": {
   "kind": "tick",
   "page": 16,
   "boxes": [
    [
     65.5,
     666.3,
     76.6,
     677.4
    ]
   ]
  },
  "q46_no": {
   "kind": "tick",
   "page": 16,
   "boxes": [
    [
     348.8,
     90.8,
     359.9,
     101.9
    ]
   ]
  },
  "q46_yes": {
   "kind": "tick",
   "page": 16,
   "boxes": [
    [
     348.8,
     109.3,
     359.9,
     120.3
    ]
   ]
  },
  "q50_1_name": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     336.0,
     422.5,
     562.6,
     442.1
    ]
   ]
  },
  "q50_1_type": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     336.0,
     494.8,
     562.6,
     514.4
    ]
   ]
  },
  "q50_1_balance": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     336.0,
     531.6,
     449.2,
     551.2
    ]
   ]
  },
  "q50_1_share_you": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     406.9,
     557.1,
     449.2,
     576.7
    ]
   ]
  },
  "q50_1_share_partner": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     520.3,
     557.1,
     562.6,
     576.7
    ]
   ]
  },
  "q50_2_name": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     336.0,
     603.9,
     562.6,
     623.5
    ]
   ]
  },
  "q50_2_type": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     336.0,
     676.2,
     562.6,
     695.8
    ]
   ]
  },
  "q50_2_balance": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     336.0,
     713.0,
     449.2,
     732.6
    ]
   ]
  },
  "q50_2_share_you": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     406.9,
     738.5,
     449.2,
     758.1
    ]
   ]
  },
  "q50_2_share_partner": {
   "kind": "text",
   "page": 17,
   "boxes": [
    [
     520.3,
     738.5,
     562.6,
     758.1
    ]
   ]
  },
  "q51_no": {
   "kind": "tick",
   "page": 18,
   "boxes": [
    [
     65.3,
     431.0,
     76.4,
     442.1
    ]
   ]
  },
  "q51_yes": {
   "kind": "tick",
   "page": 18,
   "boxes": [
    [
     65.3,
     449.4,
     76.4,
     460.5
    ]
   ]
  },
  "q51_1_institution": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     58.1,
     562.6,
     77.7
    ]
   ]
  },
  "q51_1_fund": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     95.1,
     562.6,
     114.7
    ]
   ]
  },
  "q51_1_balance": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     156.0,
     440.7,
     175.6
    ]
   ],
   "padLeft": 11.5
  },
  "q51_1_income": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     205.6,
     446.3,
     225.2
    ]
   ],
   "padLeft": 11.5
  },
  "q51_1_often": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     452.3,
     205.6,
     562.6,
     225.2
    ]
   ],
   "padLeft": 18.7
  },
  "q51_1_share_you": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     473.5,
     251.0,
     515.8,
     270.6
    ]
   ]
  },
  "q51_1_share_partner": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     520.3,
     251.0,
     562.6,
     270.6
    ]
   ]
  },
  "q51_2_institution": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     296.2,
     562.6,
     315.8
    ]
   ]
  },
  "q51_2_fund": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     333.2,
     562.6,
     352.8
    ]
   ]
  },
  "q51_2_balance": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     394.1,
     440.7,
     413.7
    ]
   ],
   "padLeft": 11.5
  },
  "q51_2_income": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     336.0,
     443.7,
     446.3,
     463.3
    ]
   ],
   "padLeft": 11.5
  },
  "q51_2_often": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     452.3,
     443.7,
     562.6,
     463.3
    ]
   ],
   "padLeft": 18.7
  },
  "q51_2_share_you": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     473.5,
     489.1,
     515.8,
     508.7
    ]
   ]
  },
  "q51_2_share_partner": {
   "kind": "text",
   "page": 18,
   "boxes": [
    [
     520.3,
     489.1,
     562.6,
     508.7
    ]
   ]
  },
  "q52_no": {
   "kind": "tick",
   "page": 19,
   "boxes": [
    [
     65.3,
     280.8,
     76.4,
     291.8
    ]
   ]
  },
  "q53_no": {
   "kind": "tick",
   "page": 19,
   "boxes": [
    [
     348.8,
     246.7,
     359.9,
     257.8
    ]
   ]
  },
  "q53_yes": {
   "kind": "tick",
   "page": 19,
   "boxes": [
    [
     348.8,
     265.2,
     359.9,
     276.3
    ]
   ]
  },
  "q53_1_company": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     336.0,
     333.2,
     562.6,
     352.8
    ]
   ]
  },
  "q53_1_share_you": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     452.3,
     438.1,
     503.0,
     457.7
    ]
   ]
  },
  "q53_1_share_partner": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     510.4,
     438.1,
     561.1,
     457.7
    ]
   ]
  },
  "q53_2_company": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     336.0,
     486.3,
     562.6,
     505.9
    ]
   ]
  },
  "q53_2_share_you": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     452.3,
     567.1,
     503.0,
     586.6
    ]
   ]
  },
  "q53_2_share_partner": {
   "kind": "text",
   "page": 19,
   "boxes": [
    [
     510.4,
     567.1,
     561.1,
     586.6
    ]
   ]
  },
  "q54_no": {
   "kind": "tick",
   "page": 20,
   "boxes": [
    [
     65.3,
     238.7,
     76.4,
     249.8
    ]
   ]
  },
  "q55_no": {
   "kind": "tick",
   "page": 20,
   "boxes": [
    [
     348.8,
     82.3,
     359.9,
     93.4
    ]
   ]
  },
  "q55_yes": {
   "kind": "tick",
   "page": 20,
   "boxes": [
    [
     348.8,
     100.8,
     359.9,
     111.8
    ]
   ]
  },
  "q55_1_company": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     335.9,
     181.4,
     562.1,
     201.0
    ]
   ]
  },
  "q55_1_value": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     335.5,
     318.4,
     447.7,
     338.0
    ]
   ],
   "padLeft": 11.5
  },
  "q55_1_share_you": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     452.2,
     318.4,
     503.0,
     338.0
    ]
   ]
  },
  "q55_1_share_partner": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     510.1,
     318.4,
     560.9,
     338.0
    ]
   ]
  },
  "q55_2_company": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     335.9,
     362.8,
     562.1,
     382.4
    ]
   ]
  },
  "q55_2_value": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     335.5,
     499.8,
     447.7,
     519.4
    ]
   ],
   "padLeft": 11.5
  },
  "q55_2_share_you": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     452.2,
     499.8,
     503.0,
     519.4
    ]
   ]
  },
  "q55_2_share_partner": {
   "kind": "text",
   "page": 20,
   "boxes": [
    [
     510.1,
     499.8,
     560.9,
     519.4
    ]
   ]
  },
  "q56_no": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     65.3,
     69.6,
     76.4,
     80.7
    ]
   ]
  },
  "q56_yes": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     65.3,
     88.0,
     76.4,
     99.1
    ]
   ]
  },
  "q56_1_product": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     52.6,
     154.6,
     279.1,
     174.2
    ]
   ]
  },
  "q56_1_share_you": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     170.2,
     238.2,
     221.0,
     257.8
    ]
   ]
  },
  "q56_1_share_partner": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     228.3,
     238.5,
     279.1,
     258.1
    ]
   ]
  },
  "q56_2_product": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     52.6,
     283.6,
     279.1,
     303.2
    ]
   ]
  },
  "q56_2_share_you": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     170.2,
     367.2,
     221.0,
     386.8
    ]
   ]
  },
  "q56_2_share_partner": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     228.3,
     367.5,
     279.1,
     387.1
    ]
   ]
  },
  "q57_no": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     65.3,
     486.3,
     76.4,
     497.4
    ]
   ]
  },
  "q57_yes": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     65.3,
     504.7,
     76.4,
     515.8
    ]
   ]
  },
  "q57_amount": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     52.6,
     541.5,
     162.9,
     561.1
    ]
   ],
   "padLeft": 12.2
  },
  "q58_no": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     348.8,
     119.2,
     359.9,
     130.3
    ]
   ]
  },
  "q58_yes": {
   "kind": "tick",
   "page": 21,
   "boxes": [
    [
     348.8,
     137.6,
     359.9,
     148.7
    ]
   ]
  },
  "q58_1_who": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     335.8,
     276.5,
     562.3,
     296.1
    ]
   ]
  },
  "q58_1_date": {
   "kind": "date",
   "page": 21,
   "boxes": [
    [
     336.0,
     313.4,
     364.4,
     333.2
    ],
    [
     370.0,
     313.4,
     398.4,
     333.2
    ],
    [
     404.1,
     313.4,
     460.8,
     333.2
    ]
   ]
  },
  "q58_1_amount": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     336.0,
     351.6,
     446.3,
     371.2
    ]
   ],
   "padLeft": 11.5
  },
  "q58_1_balance": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     452.2,
     351.5,
     562.6,
     371.1
    ]
   ],
   "padLeft": 11.5
  },
  "q58_1_share_you": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     395.6,
     378.6,
     446.3,
     398.1
    ]
   ]
  },
  "q58_1_share_partner": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     511.8,
     378.6,
     562.6,
     398.1
    ]
   ]
  },
  "q58_2_who": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     335.8,
     423.9,
     562.3,
     443.5
    ]
   ]
  },
  "q58_2_date": {
   "kind": "date",
   "page": 21,
   "boxes": [
    [
     336.0,
     460.8,
     364.4,
     480.6
    ],
    [
     370.0,
     460.8,
     398.4,
     480.6
    ],
    [
     404.1,
     460.8,
     460.8,
     480.6
    ]
   ]
  },
  "q58_2_amount": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     336.0,
     499.0,
     446.3,
     518.6
    ]
   ],
   "padLeft": 11.5
  },
  "q58_2_balance": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     452.2,
     498.9,
     562.6,
     518.5
    ]
   ],
   "padLeft": 11.5
  },
  "q58_2_share_you": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     395.6,
     526.0,
     446.3,
     545.5
    ]
   ]
  },
  "q58_2_share_partner": {
   "kind": "text",
   "page": 21,
   "boxes": [
    [
     511.8,
     526.0,
     562.6,
     545.5
    ]
   ]
  },
  "q59_no": {
   "kind": "tick",
   "page": 22,
   "boxes": [
    [
     65.3,
     440.9,
     76.4,
     452.0
    ]
   ]
  },
  "q59_yes": {
   "kind": "tick",
   "page": 22,
   "boxes": [
    [
     65.3,
     459.3,
     76.4,
     470.4
    ]
   ]
  },
  "q60_no": {
   "kind": "tick",
   "page": 22,
   "boxes": [
    [
     348.8,
     399.8,
     359.9,
     410.9
    ]
   ]
  },
  "q60_yes": {
   "kind": "tick",
   "page": 22,
   "boxes": [
    [
     348.8,
     418.2,
     359.9,
     429.3
    ]
   ]
  },
  "q60_1_type": {
   "kind": "text",
   "page": 22,
   "boxes": [
    [
     336.0,
     526.0,
     562.6,
     545.5
    ]
   ]
  },
  "q60_1_country": {
   "kind": "text",
   "page": 22,
   "boxes": [
    [
     336.0,
     562.8,
     562.6,
     582.4
    ]
   ]
  },
  "q60_1_amount": {
   "kind": "text",
   "page": 22,
   "boxes": [
    [
     336.0,
     611.3,
     446.3,
     630.9
    ]
   ]
  },
  "q61_no": {
   "kind": "tick",
   "page": 23,
   "boxes": [
    [
     65.3,
     348.8,
     76.4,
     359.9
    ]
   ]
  },
  "q61_yes": {
   "kind": "tick",
   "page": 23,
   "boxes": [
    [
     65.3,
     368.6,
     76.4,
     379.7
    ]
   ]
  },
  "q62_no": {
   "kind": "tick",
   "page": 23,
   "boxes": [
    [
     348.8,
     275.1,
     359.9,
     286.2
    ]
   ]
  },
  "q62_yes": {
   "kind": "tick",
   "page": 23,
   "boxes": [
    [
     348.8,
     293.5,
     359.9,
     304.6
    ]
   ]
  },
  "q64_no": {
   "kind": "tick",
   "page": 23,
   "boxes": [
    [
     348.8,
     633.7,
     359.9,
     644.8
    ]
   ]
  },
  "q64_yes": {
   "kind": "tick",
   "page": 23,
   "boxes": [
    [
     348.8,
     652.1,
     359.9,
     663.2
    ]
   ]
  },
  "q65_no": {
   "kind": "tick",
   "page": 24,
   "boxes": [
    [
     65.3,
     266.6,
     76.4,
     277.7
    ]
   ]
  },
  "q65_yes": {
   "kind": "tick",
   "page": 24,
   "boxes": [
    [
     65.3,
     286.4,
     76.4,
     297.5
    ]
   ]
  },
  "q65_1_description": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     52.4,
     353.0,
     278.9,
     372.6
    ]
   ]
  },
  "q65_1_value": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     52.5,
     389.9,
     162.8,
     409.5
    ]
   ]
  },
  "q65_1_share_you": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     166.0,
     438.0,
     218.1,
     457.5
    ]
   ]
  },
  "q65_1_share_partner": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     221.9,
     438.0,
     278.2,
     457.5
    ]
   ]
  },
  "q65_2_description": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     52.4,
     484.8,
     278.9,
     504.4
    ]
   ]
  },
  "q65_2_value": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     52.5,
     521.7,
     162.8,
     541.3
    ]
   ]
  },
  "q65_2_share_you": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     166.0,
     569.8,
     218.1,
     589.4
    ]
   ]
  },
  "q65_2_share_partner": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     221.9,
     569.8,
     278.2,
     589.4
    ]
   ]
  },
  "q66_no": {
   "kind": "tick",
   "page": 24,
   "boxes": [
    [
     348.8,
     266.6,
     359.9,
     277.7
    ]
   ]
  },
  "q66_yes": {
   "kind": "tick",
   "page": 24,
   "boxes": [
    [
     348.8,
     286.4,
     359.9,
     297.5
    ]
   ]
  },
  "q66_1_type": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     336.0,
     365.8,
     562.6,
     385.4
    ]
   ]
  },
  "q66_1_gross": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     336.0,
     402.6,
     562.6,
     422.2
    ]
   ],
   "padLeft": 12.2,
   "perAt": 127.4
  },
  "q66_2_type": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     336.0,
     497.6,
     562.6,
     517.2
    ]
   ]
  },
  "q66_2_gross": {
   "kind": "text",
   "page": 24,
   "boxes": [
    [
     336.0,
     534.5,
     562.6,
     554.0
    ]
   ],
   "padLeft": 12.2,
   "perAt": 127.4
  }
 }
}